import React, {Component, useEffect, useState} from "react";
import {CheckMember} from './fetch.js';
import Autocomplete from '@material-ui/lab/Autocomplete';

import {
    Avatar, Box, Button, Checkbox,
    Container, createMuiTheme,
    CssBaseline,
    FormControlLabel,
    Grid, Hidden, Link,
    makeStyles, Modal,
    TextField,
    Typography
} from "@material-ui/core";
import {Copyright} from "@material-ui/icons";

const theme = createMuiTheme();

/*
let MainContainer = {
    position: 'absolute',
    background: 'white',
    top: '2em',
    left: '2em',
    bottom: '2em',
}
*/

const paper = {
    marginTop: '20px',
    // marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
}
const avatar = {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
}
const form = {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
}
const submit = {
    margin: theme.spacing(3, 0, 2),
}

const countryToFlag = (isoCode) => {
    return typeof String.fromCodePoint !== 'undefined'
        ? isoCode
            .toUpperCase()
            .replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
        : isoCode;
}

export default class MemberRegistrationForm extends React.PureComponent {

    AnchorElement = {
        textDecoration: 'none',
        color: 'blue'
    }

    ModalLabel = {
        fontSize: '1.5rem',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: '400',
        lineHeight: '1.334',
        letterSpacing: '0em',
        margin: '0',
    }

    ModalLabelSmall = {
        color: 'gray',
        textAlign: 'left',
        fontSize: '1.2rem',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: '400',
        lineHeight: '1.334',
        letterSpacing: '0em',
        margin: '0',
    }

    ModalBody = {
        backgroundColor: 'white',
        width: '33vw',
        marginLeft: 'auto',
        marginRight: 'auto',
        left: '0',
        right: '0',
        textAlign: 'center',
        position: 'absolute',
        top: '20%',
        padding: '20px',
    }

    MainContainer = {
        position: 'absolute',
        background: 'white',
        top: '2em',
        left: '2em',
        bottom: '2em',
    }


    constructor(props) {
        super(props);
        this.state = {
            giv: '',
            sur: '',
            tle: '',
            email: '',
            userDetails: {},
            username: '',
            password: '',
            isShowBadAuthModal: false,
            isShowTbSfn: false,
        };

    }

    getData = (actionName, data, successCallback, errorCallback) => {
        CheckMember(
            actionName,
            data,
            (result) => {
                successCallback(result);
            },
            (error) => {
                errorCallback(error);
            });
    }

    badAuthModalClosed(newValue) {

        if (newValue == 'escapeKeyDown' || newValue == 'backdropClick') {

            this.setState(
                prevState => {
                    const {isShowBadAuthModal: prevIsShowBadAuthModal} = prevState;
                    return {
                        isShowBadAuthModal: false,
                    };
                },
                () => {
                    // this.setSomeOtherState();
                }
            );

        }

    }

    tbSfnChanged(newValue) {

        if (newValue == null) {
            return;
        }

        this.setState(
            prevState => {
                const {tbSfnCode: prevIsShow} = prevState;
                return {
                    tbSfnCode: newValue.target.value,
                };
            },
            () => {
                // this.setSomeOtherState();
            }
        );

    }

    showBadAuthModal() {

        this.setState(
            prevState => {
                const {isShowBadAuthModal: prevIsShowBadAuthModal} = prevState;
                return {
                    isShowBadAuthModal: true,
                };
            },
            () => {
                // this.setSomeOtherState();
            }
        );

    }

    closeBadAuthModal(element) {
        this.setState(
            prevState => {
                const {isShowBadAuthModal: prevIsShowBadAuthModal} = prevState;
                return {
                    isShowBadAuthModal: false,
                };
            },
            () => {
                // this.setSomeOtherState();
            }
        );

    }

    submitRegistration(newValue) {

        newValue.preventDefault();

        this.getData('checkFensExternalLogin', {username: this.state.username, password: this.state.password},
            (result) => {
                debugger;
                if (result.data) {
                    const memberDetailsForm = document.getElementById('memberDetailsForm');
                    // this.state.userDetails = result.data;

                    this.setState(
                        prevState => {
                            const {giv: prevIsShow} = prevState;
                            return {
                                giv: result.data.first_name,
                            };
                        },
                        () => {
                            // this.setSomeOtherState();
                        }
                    );

                    this.setState(
                        prevState => {
                            const {sur: prevIsShow} = prevState;
                            return {
                                sur: result.data.last_name,
                            };
                        },
                        () => {
                            // this.setSomeOtherState();
                        }
                    );

                    this.setState(
                        prevState => {
                            const {tle: prevIsShow} = prevState;
                            return {
                                tle: result.data.title,
                            };
                        },
                        () => {
                            // this.setSomeOtherState();
                        }
                    );

                    this.setState(
                        prevState => {
                            const {email: prevIsShow} = prevState;
                            return {
                                email: result.data.email,
                            };
                        },
                        () => {
                            // this.setSomeOtherState();
                        }
                    );

                    /*document.getElementById('giv').value = this.state.userDetails.first_name;

                    <TextField  name="giv" type="hidden" value="{this.state.userDetails.first_name}"/>
                    <TextField  name="sur" type="hidden" value="{this.state.userDetails.last_name}"/>
                    <TextField  name="tle" type="hidden" value="{this.state.userDetails.title}"/>
                    <TextField  name="country" type="hidden" value="{this.state.userDetails.country}"/>
                    <TextField  name="wphone" type="hidden" value="{this.state.userDetails.mobile_phone}"/>
                    <TextField  name="e_mail" type="hidden" value="{this.state.userDetails.email}"/>
                    <TextField  name="Homephone_full" type="hidden" value="{this.state.userDetails.fixed_phone}"/>
*/
                    // memberDetailsForm.setAttribute('action', 'https://kenes.eventsair.com/KenesSiteRedirect/fens2021/fensredirect/contactpost/data');

                    // memberDetailsForm.setAttribute('action', 'https://kenes.eventsair.com/KenesSiteRedirect/fens22/appfensredirect/contactpost/data');

                    if(result.data.member_type.toLowerCase() == 'associate')
                    {
                        memberDetailsForm.setAttribute('action', 'https://kenes.eventsair.com/KenesSiteRedirect/fens22/appassociate--memberredirect/contactpost/data');
                    }
                    if(result.data.member_type.toLowerCase() == 'full')
                    {
                        memberDetailsForm.setAttribute('action', 'https://kenes.eventsair.com/KenesSiteRedirect/fens22/appfensredirect/contactpost/data');
                    }

                    memberDetailsForm.submit();
                } else {
                    this.showBadAuthModal();
                }
            },
            (error) => {
                debugger;
                this.showBadAuthModal();
            }
        );
    }

    onWindowResize = () => {
        if (window.innerWidth < 500 || window.innerHeight < 500) {
            this.MainContainer = {
                position: 'unset',
                background: 'white',
                top: '2em',
                left: '2em',
                bottom: '2em',
            }
            this.ModalBody = {
                backgroundColor: 'white',
                width: '77vw',
                marginLeft: 'auto',
                marginRight: 'auto',
                left: '0',
                right: '0',
                textAlign: 'center',
                position: 'absolute',
                top: '33%',
                padding: '10px',
            }

        }
    }

    render() {

        window.addEventListener('resize', this.onWindowResize, false);

        if (window.innerWidth < 500 || window.innerHeight < 500) {
            this.MainContainer = {
                position: 'unset',
                background: 'white',
                top: '2em',
                left: '2em',
                bottom: '2em',
            }
            this.ModalBody = {
                backgroundColor: 'white',
                width: '77vw',
                marginLeft: 'auto',
                marginRight: 'auto',
                left: '0',
                right: '0',
                textAlign: 'center',
                position: 'absolute',
                top: '33%',
                padding: '10px',
            }
        }

        return (
            <Container style={this.MainContainer} component="main" maxWidth="xs">
                <CssBaseline/>
                <img style={{width: '50%', marginTop: '10px'}}
                     src={"https://forum.fens.org/wp-content/uploads/sites/129/2018/07/logo-white-bg-new1.png"}/>
                <div style={paper}>
                    <Avatar style={avatar}>
                        {/*<LockOutlinedIcon/>*/}
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Register
                    </Typography>
                    <form id="memberDetailsForm" method="post" style={form}
                          onSubmit={(element) => {
                              this.submitRegistration(element);
                          }}
                    >
                        <TextField  name="giv" type="hidden" value={this.state.giv}/>
                        <TextField  name="sur" type="hidden" value={this.state.sur}/>
                        <TextField  name="tle" type="hidden" value={this.state.tle}/>
                        <TextField  name="e_mail" type="hidden" value={this.state.email}/>
                        {/*<TextField  name="usrfld_t5" type="hidden" value=""/>*/}
                        {/*<TextField  name="usrfld_t41" type="hidden" value=""/>*/}
                        {/*<TextField  name="usrfld_t44" type="hidden" value=""/>*/}
                        {/*<TextField  name="add1" type="hidden" value=""/>*/}
                        {/*<TextField  name="add2" type="hidden" value=""/>*/}
                        {/*<TextField  name="add3" type="hidden" value=""/>*/}
                        {/*<TextField  name="add4" type="hidden" value=""/>*/}
                        {/*<TextField  name="suburb" type="hidden" value=""/>*/}
                        {/*<TextField  name="state" type="hidden" value=""/>*/}
                        {/*<TextField  name="pcode" type="hidden" value=""/>*/}
                        {/*<TextField  name="country" type="hidden" value="{this.state.userDetails.country}"/>*/}
                        {/*<TextField  name="wphone" type="hidden" value="{this.state.userDetails.mobile_phone}"/>*/}
                        {/*<TextField  name="Homephone_full" type="hidden" value="{this.state.userDetails.fixed_phone}"/>*/}

                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    id="username"
                                    name="username"
                                    onChange={(element) => {
                                        this.tbUsernameChanged(element);
                                    }}
                                    autoComplete="username"
                                    variant="outlined"
                                    required
                                    fullWidth
                                    label="Username"
                                    autoFocus
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="password"
                                    type="password"
                                    name="password"
                                    onChange={(element) => {
                                        this.tbPasswordChanged(element);
                                    }}
                                    variant="outlined"
                                    required
                                    fullWidth
                                    label="Password"
                                    autoComplete="password"
                                />
                                <a style={this.AnchorElement} target="_blank" href="https://www.fens.org/members/forgot">Forgot password?</a>

                                <p>
                                    If you are having issues registering for the Forum as a FENS member, please ensure you are using your FENS ID in the Username field to register, not your email.
                                    Your FENS ID is visible on your <a href="https://www.fens.org/">fens.org</a> profile page, on the My FENS membership tab, in the upper right corner (example: FENS00001).
                                </p>
                                <p>
                                    If you still cannot register, try resetting your password on <a href="https://www.fens.org/">fens.org</a>, and then try to register for the Forum again using your FENS ID and updated password.
                                    If none of these steps solved the issue, please contact the FENS administration at <a href="mailto:office@fens.org">office@fens.org</a> .
                                </p>
                            </Grid>
                            {/*<Grid item xs={12}>
                                <FormControlLabel
                                    control={<Checkbox value="allowExtraEmails" color="primary"/>}
                                    label="I want to receive inspiration, marketing promotions and updates via email."
                                />
                            </Grid>*/}
                        </Grid>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            style={submit}
                        >
                            Submit
                        </Button>
                        {/*<Grid container justify="flex-end">
                            <Grid item>
                                <Link href="#" variant="body2">
                                    Already have an account? Sign in
                                </Link>
                            </Grid>
                        </Grid>*/}
                    </form>
                </div>
                <Modal
                    open={this.state.isShowBadAuthModal}
                    onClose={(event, newValue) => {
                        this.badAuthModalClosed(newValue);
                    }}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                >
                    <div style={this.ModalBody}>
                        {/*<img style={{width: '50%', marginTop: '10px'}}
                             src={"https://forum.fens.org/wp-content/uploads/sites/129/2018/07/logo-white-bg-new1.png"}/>*/}
                        <table style={{width: '100%',}}>
                            <tr>
                                <td>
                                    <p style={this.ModalLabel}>Incorrect Username or Password</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <br/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p style={this.ModalLabelSmall}>According to the membership details provided by the FENS Society, you currently do not appear as an active FENS member, or your login details are incorrect. If you forgot your login credentials you may retrieve these <a style={this.AnchorElement} target="_blank" href="https://www.fens.org/members/forgot">here</a>.</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <br/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p style={this.ModalLabelSmall}>You may also contact FENS society services at: <a style={this.AnchorElement} target="_blank" href="mailto:office@fens.org">office@fens.org</a> to verify the status of your membership, or alternatively register as a non-member via the online registration link <a style={this.AnchorElement} target="_blank" href="https://apps.kenes.com/FensReg/nonmember/">here</a></p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <br/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={(element) => {
                                            this.closeBadAuthModal(element);
                                        }}
                                    >
                                        Ok
                                    </Button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </Modal>
                {/*<Box mt={5}>
                    <Copyright/>
                </Box>*/}
            </Container>
        );
    }


    tbUsernameChanged(newValue) {

        if (newValue == null) {
            return;
        }

        this.setState(
            prevState => {
                const {username: prevIsShow} = prevState;
                return {
                    username: newValue.target.value,
                };
            },
            () => {
                // this.setSomeOtherState();
            }
        );

    }

    tbPasswordChanged(newValue) {

        if (newValue == null) {
            return;
        }

        this.setState(
            prevState => {
                const {password: prevIsShow} = prevState;
                return {
                    password: newValue.target.value,
                };
            },
            () => {
                // this.setSomeOtherState();
            }
        );

    }
}

// export default RegistrationForm;
